import * as React from 'react';
import { routeNode, IRouteNodeProps } from 'react-mobx-router5';

// Constants
import { ROUTE_PATHS, ROUTE_NAMES } from '../../constants/routes';

// Types
import { ITagQuery, ITag } from './AppNetworkPeople';

// Components

import AppNetworkPeopleSearch from '../AppNetworkPeopleSearch';
import AppNetworkPeopleStatistics from '../AppNetworkPeopleStatistics';
import AppNetworkPeopleMyTags from '../AppNetworkPeopleMyTags';

// Component
export interface IProps extends IRouteNodeProps {
  tagQuery: ITagQuery[];
  parentTag: { tagId: string };
  getTags: () => void;
  tags: ITag[] | null;
  onTagRemove: (tagId: string) => void;
}

class Router extends React.Component<IProps, {}> {
  render() {
    if (!this.props.route) {
      return <h1>Not Found</h1>;
    }
    const segment = this.props.route.name.split('.')[3];
    switch (segment) {
      case ROUTE_NAMES.APP_NETWORK_PEOPLE_SEARCH:
        return <AppNetworkPeopleSearch tagQuery={this.props.tagQuery} />;
      case ROUTE_NAMES.APP_NETWORK_PEOPLE_STATISTICS:
        return (
          <AppNetworkPeopleStatistics
            tagQuery={this.props.tagQuery}
            parentTag={this.props.parentTag}
          />
        );
      case ROUTE_NAMES.APP_NETWORK_PEOPLE_MYTAGS:
        return (
          <AppNetworkPeopleMyTags
            getTags={this.props.getTags}
            tags={this.props.tags}
            onTagRemove={this.props.onTagRemove}
          />
        );
      default:
        return <h1>Something Went wrong</h1>;
    }
  }
}

export default routeNode<IProps>(ROUTE_PATHS.APP_NETWORK_PEOPLE)(Router);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeople/Router.tsx